import * as C from "./styles";

export default function Null() {
  return <C.Container></C.Container>;
}
